// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_glass__d8GZw {
  @apply h-5/6 w-5/6;
}

.Profile_profile_img__nIq7t {
  @apply w-40 cursor-pointer;
}

.Profile_textbox__A\\+ja7 {
  @apply w-3/4;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Profile.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd","sourcesContent":[".glass {\n  @apply h-5/6 w-5/6;\n}\n\n.profile_img {\n  @apply w-40 cursor-pointer;\n}\n\n.textbox {\n  @apply w-3/4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"glass": `Profile_glass__d8GZw`,
	"profile_img": `Profile_profile_img__nIq7t`,
	"textbox": `Profile_textbox__A+ja7`
};
export default ___CSS_LOADER_EXPORT___;
